/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { EmailNotificationTypes } from './EmailNotificationTypes';
import { NotificationSettingOption } from './NotificationSettingOption';
const NotificationSettingParser = /* #__PURE__ */ parsers.object([
    ['options', /* #__PURE__ */ codecArray(NotificationSettingOption)],
    [
        'possibleValues',
        /* #__PURE__ */ codecArray(EmailNotificationTypes),
        'possible_values',
    ],
]);
export class NotificationSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NotificationSettingParser.decode(input).map(res => new NotificationSetting(res));
    }
    static unsafeDecode(input) {
        return NotificationSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationSettingParser.encode(data);
    }
    static schema() {
        return NotificationSettingParser.schema();
    }
}
